export enum DrawerType {
    PERSONAL_SETTINGS,
    ACCOUNT_SETTINGS,
    TIPS_AND_TRICKS,
    NOTIFICATIONS
}